import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../api/auth";
import PublicNav from "../components/PublicNav";

/* ═══════════════════════════════════════
   COULEURS SETRAG
═══════════════════════════════════════ */
const C = {
  green:    "#006B3C",
  greenDk:  "#004D2B",
  greenLt:  "#E8F5EE",
  greenMid: "#00894D",
  yellow:   "#FFC300",
  yellowLt: "#FFF8DC",
  white:    "#FFFFFF",
  gray:     "#F5F5F5",
  grayBd:   "#E0E0E0",
  text:     "#1A1A1A",
  textSub:  "#666666",
};

/* ═══════════════════════════════════════
   ICONS
═══════════════════════════════════════ */
const MailIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="1" y="3" width="14" height="10" rx="2" stroke={C.textSub} strokeWidth="1.5"/><path d="M1 6l7 4 7-4" stroke={C.textSub} strokeWidth="1.5"/></svg>;
const PhoneIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M3 1h4l1.5 4-2 1.2a9.1 9.1 0 004.3 4.3L12 8.5 16 10v4a2 2 0 01-2 2A15 15 0 011 3a2 2 0 012-2z" stroke={C.textSub} strokeWidth="1.5" strokeLinejoin="round"/></svg>;
const LockIcon   = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><rect x="3" y="7" width="10" height="8" rx="2" stroke={C.textSub} strokeWidth="1.5"/><path d="M5 7V5a3 3 0 016 0v2" stroke={C.textSub} strokeWidth="1.5"/></svg>;
const EyeIcon    = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M1 8s2.5-5 7-5 7 5 7 5-2.5 5-7 5-7-5-7-5z" stroke={C.textSub} strokeWidth="1.5"/><circle cx="8" cy="8" r="2" stroke={C.textSub} strokeWidth="1.5"/></svg>;
const EyeOffIcon = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><path d="M2 2l12 12M6.5 6.6A2 2 0 0010 10M4 4.3C2.4 5.4 1 8 1 8s2.5 5 7 5c1.4 0 2.7-.4 3.8-1M7 3.1C7.3 3 7.6 3 8 3c4.5 0 7 5 7 5s-.6 1.2-1.6 2.3" stroke={C.textSub} strokeWidth="1.5" strokeLinecap="round"/></svg>;
const AlertIcon  = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink:0 }}><circle cx="8" cy="8" r="7" stroke="#f87171" strokeWidth="1.5"/><path d="M8 5v4M8 11v.5" stroke="#f87171" strokeWidth="1.5" strokeLinecap="round"/></svg>;
const SpinIcon   = () => <span style={{ display:"inline-block", width:14, height:14, border:"2px solid rgba(255,255,255,0.35)", borderTopColor:"white", borderRadius:"50%", animation:"setrag-spin 0.6s linear infinite", marginRight:8, verticalAlign:"middle" }} />;
const TrainIcon  = () => <svg width="26" height="26" viewBox="0 0 24 24" fill="none"><rect x="4" y="3" width="16" height="13" rx="2" stroke="currentColor" strokeWidth="1.6"/><path d="M4 10h16M8 16l-2 4M16 16l2 4M9 10V6M15 10V6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="8.5" cy="13.5" r="1" fill="currentColor"/><circle cx="15.5" cy="13.5" r="1" fill="currentColor"/></svg>;

/* ═══════════════════════════════════════
   FORCE MOT DE PASSE
═══════════════════════════════════════ */
const pwStrength = (p) => {
  if (!p) return { score:0, label:"", color:C.grayBd };
  let score = 0;
  if (p.length >= 8)           score++;
  if (/[A-Z]/.test(p))         score++;
  if (/[0-9]/.test(p))         score++;
  if (/[^A-Za-z0-9]/.test(p))  score++;
  const map = [
    { label:"", color:C.grayBd },
    { label:"Faible",    color:"#f87171" },
    { label:"Moyen",     color:"#fbbf24" },
    { label:"Bon",       color:"#34d399" },
    { label:"Excellent", color:C.green },
  ];
  return { score, ...map[score] };
};

/* ═══════════════════════════════════════
   INDICATEUR D'ÉTAPES
═══════════════════════════════════════ */
const StepIndicator = ({ current }) => {
  const steps = ["Identité", "Nouveau mot de passe", "Confirmé"];
  return (
    <div style={{ display:"flex", alignItems:"flex-end", marginBottom:28 }}>
      {steps.map((label, i) => {
        const idx    = i + 1;
        const done   = idx < current;
        const active = idx === current;
        return (
          <React.Fragment key={label}>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:6 }}>
              <div style={{
                width:30, height:30, borderRadius:"50%",
                border:`2px solid ${done ? C.green : active ? C.green : C.grayBd}`,
                background: done ? C.green : active ? C.greenLt : "transparent",
                color: done ? "#fff" : active ? C.green : C.textSub,
                display:"flex", alignItems:"center", justifyContent:"center",
                fontSize:12, fontWeight:700,
              }}>
                {done ? "✓" : idx}
              </div>
              <div style={{ fontSize:10, color: active ? C.green : C.textSub, fontWeight: active ? 700 : 400, whiteSpace:"nowrap", textTransform:"uppercase", letterSpacing:0.5 }}>{label}</div>
            </div>
            {i < 2 && (
              <div style={{ flex:1, height:"2px", background: done ? C.green : C.grayBd, alignSelf:"center", marginBottom:18, transition:"background 0.3s" }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

/* ═══════════════════════════════════════
   PANEL GAUCHE – THÈME SETRAG
═══════════════════════════════════════ */
const PanelLeft = ({ step }) => (
  <div style={s.panel} className="setrag-panel">
    <svg style={s.panelBg} viewBox="0 0 440 700" preserveAspectRatio="xMidYMid slice">
      <defs>
        <pattern id="rail-grid3" width="44" height="44" patternUnits="userSpaceOnUse">
          <path d="M 44 0 L 0 0 0 44" fill="none" stroke="rgba(255,255,255,0.04)" strokeWidth="0.6"/>
        </pattern>
      </defs>
      <rect width="440" height="700" fill="url(#rail-grid3)"/>
      <circle cx="70"  cy="580" r="220" fill="rgba(255,195,0,0.04)"/>
      <circle cx="370" cy="120" r="180" fill="rgba(255,195,0,0.05)"/>
      <g opacity="0.09">
        <line x1="62"  y1="0" x2="62"  y2="700" stroke="#FFC300" strokeWidth="1.5"/>
        <line x1="98"  y1="0" x2="98"  y2="700" stroke="#FFC300" strokeWidth="1.5"/>
        {[60,140,220,300,380,460,540,620].map(y => (
          <line key={y} x1="55" y1={y} x2="105" y2={y} stroke="#FFC300" strokeWidth="3"/>
        ))}
      </g>
      <circle cx="220" cy="350" r="100" fill="none" stroke="rgba(255,195,0,0.07)" strokeWidth="0.8"/>
      <circle cx="220" cy="350" r="160" fill="none" stroke="rgba(255,195,0,0.04)" strokeWidth="0.8"/>
    </svg>

    <div style={s.panelContent}>
      <Link to="/" style={{ ...s.panelLogo, textDecoration:"none" }}>
        <span style={{ color:C.yellow }}><TrainIcon /></span>
        <div>
          <div style={{ fontWeight:800, fontSize:20, letterSpacing:2 }}>SETRAG</div>
          <div style={{ fontSize:10, color:"rgba(255,255,255,0.5)", letterSpacing:3 }}>TRANSGABONAIS</div>
        </div>
      </Link>

      <div style={{ margin:"auto 0" }}>
        <div style={{ display:"inline-block", background:"rgba(255,195,0,0.15)", border:"1px solid rgba(255,195,0,0.3)", borderRadius:20, padding:"4px 14px", fontSize:11, color:C.yellow, marginBottom:16, letterSpacing:1 }}>
          🔐 Sécurité du compte
        </div>
        <h2 style={s.panelTitle}>
          {step === 1 ? "Récupérez l'accès à votre compte" :
           step === 2 ? "Choisissez un nouveau mot de passe" :
                        "Compte récupéré avec succès !"}
        </h2>
        <p style={s.panelSub}>
          {step === 1
            ? "Entrez votre email ou votre téléphone (celui utilisé à l'inscription) pour vérifier votre identité en toute sécurité."
            : step === 2
            ? "Votre identité a été confirmée. Définissez un nouveau mot de passe sécurisé pour votre compte."
            : "Votre mot de passe a été réinitialisé. Vous pouvez maintenant accéder à votre espace voyageur."}
        </p>
      </div>

      {/* Conseils sécurité */}
      <div style={s.tipBox}>
        <div style={{ fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:1, color:C.yellow, marginBottom:12 }}>
          Conseils de sécurité
        </div>
        {[
          "Ne partagez jamais votre mot de passe",
          "Utilisez au moins 8 caractères",
          "Mélangez lettres, chiffres et symboles",
          "Évitez les mots communs ou votre nom",
        ].map(tip => (
          <div key={tip} style={{ display:"flex", gap:10, marginBottom:8 }}>
            <span style={{ color:C.yellow, flexShrink:0, fontSize:12 }}>→</span>
            <span style={{ fontSize:12, color:"rgba(255,255,255,0.45)", lineHeight:1.5 }}>{tip}</span>
          </div>
        ))}
      </div>

      <div style={s.panelFooter}>
        <Link to="/login" style={{ fontSize:12, color:"rgba(255,255,255,0.4)", textDecoration:"none" }}>
          ← Retour à la connexion
        </Link>
      </div>
    </div>
  </div>
);

/* ═══════════════════════════════════════
   PAGE MOT DE PASSE OUBLIÉ
═══════════════════════════════════════ */
const ForgetPassword = () => {
  const navigate = useNavigate();

  const [step,     setStep]     = useState(1);
  const [authMethod, setAuthMethod] = useState("email"); // "email" | "phone" - un seul choix à la fois
  const [email,    setEmail]    = useState("");
  const [phone,    setPhone]    = useState("");
  const [token,    setToken]    = useState("");
  const [password, setPassword] = useState("");
  const [confirm,  setConfirm]  = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const [showPwd,  setShowPwd]  = useState(false);
  const [showCPwd, setShowCPwd] = useState(false);

  const strength = pwStrength(password);

  const switchAuthMethod = (method) => {
    setAuthMethod(method);
    setError("");
    // On vide le champ non utilisé pour ne jamais envoyer une valeur
    // oubliée/incohérente avec le mode choisi.
    if (method === "email") setPhone("");
    else setEmail("");
  };

  const handleVerify = async () => {
    setError("");
    const value = authMethod === "email" ? email : phone;
    if (!value.trim()) {
      setError(authMethod === "email" ? "Renseignez votre email." : "Renseignez votre numéro de téléphone.");
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(API.MDP + "/forgot-password", { email, phone });
      setToken(res.data.reset_token);
      setStep(2);
    } catch {
      setError(authMethod === "email" ? "Email introuvable." : "Numéro de téléphone introuvable.");
    }
    setLoading(false);
  };

  const handleReset = async () => {
    setError("");
    if (password.length < 6) { setError("Le mot de passe doit contenir au moins 6 caractères."); return; }
    if (password !== confirm) { setError("Les mots de passe ne correspondent pas."); return; }
    setLoading(true);
    try {
      const res = await axios.post(API.MDP + "/reset-password", { token, password });
      localStorage.setItem("token", res.data.token);
      setStep(3);
      setTimeout(() => navigate("/dashboard"), 2500);
    } catch {
      setError("Une erreur est survenue. Veuillez recommencer.");
    }
    setLoading(false);
  };

  return (
    <>
      <PublicNav />
      <div style={s.page}>
        <style>{globalCSS}</style>
        <PanelLeft step={step} />

        <div style={s.formSide}>
          <div style={s.formBox}>

          {/* Mobile logo */}
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:28 }}>
            <div style={{ width:36, height:36, borderRadius:10, background:C.greenLt, display:"flex", alignItems:"center", justifyContent:"center" }}>
              <span style={{ color:C.green }}><TrainIcon /></span>
            </div>
            <div>
              <div style={{ fontWeight:800, fontSize:14, color:C.green, letterSpacing:1 }}>SETRAG</div>
              <div style={{ fontSize:10, color:C.textSub, letterSpacing:2 }}>TRANSGABONAIS</div>
            </div>
          </div>

          <div style={s.formHeader}>
            <h1 style={s.formTitle}>
              {step === 1 ? "Vérification d'identité" :
               step === 2 ? "Nouveau mot de passe" :
                            "Tout est bon !"}
            </h1>
            <p style={s.formSub}>
              {step === 1 ? "Confirmez votre identité pour réinitialiser votre mot de passe." :
               step === 2 ? "Choisissez un nouveau mot de passe sécurisé." :
                            "Vous allez être redirigé automatiquement…"}
            </p>
          </div>

          <StepIndicator current={step} />

          {error && <div style={s.errorBox}><AlertIcon />{error}</div>}

          {/* ── ÉTAPE 1 : Vérification ── */}
          {step === 1 && (
            <>
              <div style={{ ...s.formField, marginBottom:20 }}>
                <label style={s.label}>J'ai créé mon compte avec</label>
                <div style={{ display:"flex", gap:8 }}>
                  {[["email","Mon email"],["phone","Mon téléphone"]].map(([val,lbl]) => (
                    <button key={val} type="button" onClick={() => switchAuthMethod(val)}
                      style={{
                        flex:1, padding:"10px 12px", borderRadius:10, fontWeight:700, fontSize:13, cursor:"pointer",
                        border:`1.5px solid ${authMethod===val ? C.green : C.grayBd}`,
                        background: authMethod===val ? C.greenLt : "#fff",
                        color: authMethod===val ? C.green : C.textSub,
                      }}>
                      {authMethod===val && "✓ "}{lbl}
                    </button>
                  ))}
                </div>
              </div>

              {authMethod === "email" ? (
                <div style={{ ...s.formField, marginBottom:28 }}>
                  <label style={s.label}>Adresse email</label>
                  <div style={{ position:"relative" }}>
                    <span style={s.inputIcon}><MailIcon /></span>
                    <input style={{ ...s.input, paddingLeft:42 }} type="email" placeholder="vous@exemple.ga"
                      value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" />
                  </div>
                </div>
              ) : (
                <div style={{ ...s.formField, marginBottom:28 }}>
                  <label style={s.label}>Numéro de téléphone</label>
                  <div style={{ position:"relative" }}>
                    <span style={s.inputIcon}><PhoneIcon /></span>
                    <input style={{ ...s.input, paddingLeft:42 }} type="tel" placeholder="+241 07 XX XX XX"
                      value={phone} onChange={e => setPhone(e.target.value)} />
                  </div>
                </div>
              )}

              <button style={s.submitBtn} onClick={handleVerify} disabled={loading} className="setrag-btn">
                {loading ? <><SpinIcon />Vérification…</> : "Vérifier mon identité →"}
              </button>
            </>
          )}

          {/* ── ÉTAPE 2 : Nouveau MDP ── */}
          {step === 2 && (
            <>
              <div style={s.formField}>
                <label style={s.label}>Nouveau mot de passe</label>
                <div style={{ position:"relative" }}>
                  <span style={s.inputIcon}><LockIcon /></span>
                  <input
                    style={{ ...s.input, paddingLeft:42, paddingRight:42 }}
                    type={showPwd ? "text" : "password"}
                    placeholder="Minimum 6 caractères"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                  <button style={s.eyeBtn} type="button" onClick={() => setShowPwd(!showPwd)}>
                    {showPwd ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                </div>
              </div>

              {/* Barre de force */}
              {password && (
                <div style={{ marginBottom:14 }}>
                  <div style={{ display:"flex", gap:4, marginBottom:4 }}>
                    {[1,2,3,4].map(i => (
                      <div key={i} style={{ flex:1, height:4, borderRadius:2, background:i <= strength.score ? strength.color : C.grayBd, transition:"background 0.2s" }} />
                    ))}
                  </div>
                  <div style={{ fontSize:11, color:strength.color, fontWeight:600 }}>{strength.label}</div>
                </div>
              )}

              <div style={{ ...s.formField, marginBottom:28 }}>
                <label style={s.label}>Confirmer le mot de passe</label>
                <div style={{ position:"relative" }}>
                  <span style={s.inputIcon}><LockIcon /></span>
                  <input
                    style={{
                      ...s.input, paddingLeft:42, paddingRight:42,
                      borderColor: confirm && confirm !== password ? "#f87171"
                        : confirm && confirm === password ? C.green : undefined,
                    }}
                    type={showCPwd ? "text" : "password"}
                    placeholder="Répétez votre mot de passe"
                    value={confirm}
                    onChange={e => setConfirm(e.target.value)}
                  />
                  <button style={s.eyeBtn} type="button" onClick={() => setShowCPwd(!showCPwd)}>
                    {showCPwd ? <EyeOffIcon /> : <EyeIcon />}
                  </button>
                </div>
                {confirm && confirm === password && (
                  <div style={{ fontSize:11, color:C.green, marginTop:5, fontWeight:600 }}>✓ Mots de passe identiques</div>
                )}
              </div>

              <button style={s.submitBtn} onClick={handleReset} disabled={loading} className="setrag-btn">
                {loading ? <><SpinIcon />Réinitialisation…</> : "Réinitialiser le mot de passe"}
              </button>
            </>
          )}

          {/* ── ÉTAPE 3 : Succès ── */}
          {step === 3 && (
            <div style={{ textAlign:"center", padding:"16px 0" }}>
              <div style={{ width:80, height:80, borderRadius:"50%", background:C.greenLt, border:`3px solid ${C.green}`, display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 20px" }}>
                <span style={{ fontSize:36 }}>✅</span>
              </div>
              <h3 style={{ color:C.green, fontSize:20, fontWeight:800, marginBottom:10 }}>
                Mot de passe réinitialisé !
              </h3>
              <p style={{ color:C.textSub, fontSize:13, lineHeight:1.7, marginBottom:24 }}>
                Votre mot de passe a été mis à jour avec succès. Vous allez être redirigé vers votre tableau de bord automatiquement.
              </p>

              {/* Billet de confirmation stylisé */}
              <div style={{ background:"#fff", border:`2px dashed ${C.green}`, borderRadius:12, padding:20, textAlign:"left", marginBottom:20 }}>
                <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
                  <span style={{ fontSize:20 }}>🚆</span>
                  <span style={{ fontWeight:800, color:C.green, letterSpacing:1 }}>SETRAG</span>
                  <span style={{ marginLeft:"auto", fontSize:11, color:C.textSub }}>SÉCURITÉ</span>
                </div>
                <div style={{ borderTop:`1px dashed ${C.grayBd}`, paddingTop:12, fontSize:13 }}>
                  <p style={{ margin:"4px 0", color:C.textSub }}>🔐 Compte sécurisé avec succès</p>
                  <p style={{ margin:"4px 0", color:C.textSub }}>{email ? `📧 ${email}` : `📱 ${phone || "votre téléphone"}`}</p>
                  <p style={{ margin:"4px 0 0", fontSize:11, color:"#aaa" }}>Redirection automatique en cours…</p>
                </div>
              </div>

              <Link to="/dashboard" style={{ ...s.submitBtn, textDecoration:"none", display:"flex", alignItems:"center", justifyContent:"center" }}>
                Accéder à mon espace voyageur
              </Link>
            </div>
          )}

          {step !== 3 && (
            <div style={{ textAlign:"center", marginTop:20 }}>
              <Link to="/login" style={{ fontSize:13, color:C.textSub, textDecoration:"none" }}>
                ← Retour à la connexion
              </Link>
            </div>
          )}
        </div>
      </div>
      </div>
    </>
  );
};

export default ForgetPassword;

/* ── Styles ── */
const s = {
  page:        { display:"flex", minHeight:"100vh", fontFamily:"'Segoe UI', sans-serif" },
  panel:       { width:"42%", background:C.greenDk, position:"relative", overflow:"hidden", flexShrink:0 },
  panelBg:     { position:"absolute", inset:0, width:"100%", height:"100%" },
  panelContent:{ position:"relative", zIndex:1, display:"flex", flexDirection:"column", height:"100%", padding:"36px 40px" },
  panelLogo:   { display:"flex", alignItems:"center", gap:8, color:"#fff" },
  panelTitle:  { fontSize:26, fontWeight:800, color:"#fff", letterSpacing:-0.5, lineHeight:1.2, marginBottom:12 },
  panelSub:    { fontSize:14, color:"rgba(255,255,255,0.55)", lineHeight:1.75 },
  tipBox:      { background:"rgba(255,255,255,0.04)", border:"1px solid rgba(255,255,255,0.08)", borderRadius:12, padding:"16px 18px", margin:"28px 0" },
  panelFooter: { marginTop:"auto", paddingTop:20, borderTop:"1px solid rgba(255,255,255,0.08)" },

  formSide:    { flex:1, display:"flex", alignItems:"center", justifyContent:"center", background:C.gray, padding:"40px 32px" },
  formBox:     { width:"100%", maxWidth:420 },
  formHeader:  { marginBottom:24 },
  formTitle:   { fontSize:24, fontWeight:800, color:C.text, margin:"0 0 6px", letterSpacing:-0.5 },
  formSub:     { fontSize:13, color:C.textSub, margin:0 },

  errorBox:    { display:"flex", alignItems:"center", gap:8, background:"#fff5f5", border:"1px solid #fecaca", borderRadius:10, padding:"10px 14px", marginBottom:20, fontSize:13, color:"#dc2626" },
  formField:   { marginBottom:16 },
  label:       { display:"block", fontSize:11, fontWeight:700, color:C.textSub, marginBottom:6, textTransform:"uppercase", letterSpacing:0.5 },
  input:       { width:"100%", padding:"12px 14px", border:`1.5px solid ${C.grayBd}`, borderRadius:10, fontSize:14, fontFamily:"inherit", color:C.text, background:"#fff", outline:"none", boxSizing:"border-box", transition:"border-color 0.15s" },
  inputIcon:   { position:"absolute", left:14, top:"50%", transform:"translateY(-50%)", display:"flex", alignItems:"center", pointerEvents:"none" },
  eyeBtn:      { position:"absolute", right:12, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", padding:4, display:"flex", alignItems:"center" },
  submitBtn:   { width:"100%", padding:"13px 0", background:`linear-gradient(135deg, ${C.green}, ${C.greenMid})`, color:"#fff", border:"none", borderRadius:10, fontSize:15, fontWeight:700, cursor:"pointer", fontFamily:"inherit", display:"flex", alignItems:"center", justifyContent:"center", gap:6, letterSpacing:0.3 },
};

const globalCSS = `
  @keyframes setrag-spin { to { transform: rotate(360deg); } }
  input:focus { border-color: #006B3C !important; box-shadow: 0 0 0 3px rgba(0,107,60,0.1) !important; }
  .setrag-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
  .setrag-btn:disabled { opacity: 0.6; cursor: not-allowed; }
  .setrag-btn { transition: all 0.15s ease; }
  @media (max-width: 768px) { .setrag-panel { display: none !important; width: 0 !important; } }
`;